const productFamilies = [
  'antenna-system',
  'mobile-transport',
  'ran-compute',
  'massive-mimo',
  'remote-radio',
  'street-outdoor',
  'indoor',
  'site-system'
];

const traceDuplicatedRadioIds = radiosList => {
  let uniqueRadioIds = new Set();
  let allRadioIds = [];

  radiosList.forEach(radio => {
    allRadioIds.push(radio.id);
    uniqueRadioIds.add(radio.id);
    if (!radio.id) {
      console.log('no id:', radio);
    }
  });

  const duplicatesCount = radiosList.length - uniqueRadioIds.size;
  if (duplicatesCount) {
    console.log(`we have ${duplicatesCount} duplicate radios`);
    Array.from(uniqueRadioIds).forEach(radioId =>
      allRadioIds.splice(
        allRadioIds.findIndex(el => el === radioId),
        1
      )
    );
    console.log('duplicate radios list:', allRadioIds);
  }
};

export const getGroupsFromSections = radios => {
  let allGroups = {};
  let allRadios = [];
  // getting all groups and all radios
  radios.forEach(radio => {
    allGroups[radio.group] = {};
    allRadios.push({ ...radio });
  });

  // Adding Radios to Each Radio Family
  allRadios.forEach(radio => {
    if (allGroups[radio.group][radio.family] === undefined) {
      allGroups[radio.group][radio.family] = [];
    }
    allGroups[radio.group][radio.family].push(radio);
  });

  // We only need unique IDs, otherwise custom selection will not work correctly
  traceDuplicatedRadioIds(allRadios);

  return allGroups;
};

export const getStaticUrl = (radio, route) => {
  if(radio?.hasOwnProperty('parentId')) {
    return productFamilies.some(product => route.split('/')[0] === product)
      ? '../../../../static/'
      : '../../static/';
  }

  return productFamilies.some(product => route.split('/')[0] === product)
      ? '../../../static/'
      : '../../static/';
};
